import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const NoGiftCards = () => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-2">
      <Typography variant="body-sm" weight="bold">
        You haven&apos;t saved any gift cards.
      </Typography>
      <Typography variant="body-sm">
        Add a gift card to view balance, reload, and track your purchase history.
      </Typography>
    </div>
  );
};

export { NoGiftCards };
